import { Button, Grid } from '@material-ui/core'
import Select from '../../../control/select/select'
import { makeStyles } from '@material-ui/styles'
import { FC } from 'react'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import { FacultyFormType } from '../../../services/um/useSettingFaculty'
import useIRB from '../../../services/um/lookups/useIRB'

type InitialFormType = {
    userID?: number
    nameTH: string
    nameEN: string
    recID?: any
}
interface FormProps {
    onBack: () => void
    initialValues?: InitialFormType
    onSubmit: (values: FacultyFormType) => void
}
const Form: FC<FormProps> = ({ onBack, initialValues, onSubmit }) => {
    const classes = useStyle()
    const translate = useTranslate()
    const { irb } = useIRB()

    return (
        <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit }) => {
                return (
                    <div>
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="nameTH"
                                    materialInputProps={{
                                        label: `${translate.get('UM.SETTING_FACULTY.NAME_TH')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.SETTING_FACULTY.NAME_TH')}`,
                                        size: 'small',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="nameEN"
                                    materialInputProps={{
                                        label: `${translate.get('UM.SETTING_FACULTY.NAME_EN')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.SETTING_FACULTY.NAME_EN')}`,
                                        size: 'small',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12} sm={6}>
                                    <Select
                                        required
                                        name="recID"
                                        option={[
                                            {
                                                value: '0',
                                                label: translate.get('LABEL.NOT_SPECIFIC'),
                                            },
                                            ...irb,
                                        ]}
                                        label={translate.get('UM.SETTING_FACULTY.REC')}
                                        placeholder={translate.get('UM.SETTING_FACULTY.REC')}
                                        size="small"
                                        defaultValue={initialValues?.recID?.toString()}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            className={classes.cancelButton}
                                            onClick={onBack}
                                        >
                                            {translate.get('BUTTON.CANCEL')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            className={classes.saveButton}
                                            style={{ minWidth: '0px' }}
                                        >
                                            {translate.get('BUTTON.SAVE')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                )
            }}
        </FinalForm>
    )
}

const useStyle = makeStyles(() => ({
    container: {
        width: '100%',
    },
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    root: {
        width: '100%',
        height: '100%',
        padding: '1rem 0px',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
}))

export default Form
